export default "/images/49fb92786f8c7f29887382a45b4b9f6d.png";